import { Fade } from "@mui/material";

const AtomTabPanel = (props) => {
  const { children, value, index, id = "simple", ...other } = props;
  const isActive = value === index;

  return (
    <div
      role="tabpanel"
      // hidden={!isActive} // 👈 hide the inactive tab panels completely
      data-active={isActive}
      hidden={value !== index}
      id={`${id}-tabPanel-${index}`}
      aria-labelledby={`${id}-tab-${index}`}
      {...other}
      style={{
        // minHeight: "200px",
        // backgroundColor: "green",
        // border: "2px solid",
        // width: "100%",
        visibility: isActive ? "visible" : "hidden",
        position: isActive ? "relative" : "absolute",
        top: 0,
        left: 0,
        width: "100%",
      }} // optional to avoid layout shift
    >
      <Fade in={isActive} timeout={500}>
        <div style={{ display: isActive ? "block" : "none" }}>{children}</div>
      </Fade>
    </div>
  );
};

export default AtomTabPanel;

// import { Fade } from "@mui/material";

// const AtomTabPanel = (props) => {
//   const { children, value, index, id = "simple", ...other } = props;
//   const isActive = value === index;

//   return (
//     <div
//       role="tabpanel"
//       // hidden={!isActive} // 👈 hide the inactive tab panels completely
//       data-active={isActive}
//       hidden={value !== index}
//       id={`${id}-tabPanel-${index}`}
//       aria-labelledby={`${id}-tab-${index}`}
//       {...other}
//       style={{
//         // minHeight: "200px",
//         // backgroundColor: "green",
//         // border: "2px solid",
//         // width: "100%",
//         visibility: isActive ? "visible" : "hidden",
//         position: isActive ? "relative" : "absolute",
//         top: 0,
//         left: 0,
//         width: "100%",
//       }} // optional to avoid layout shift
//     >
//       <Fade in={isActive} timeout={500}>
//         <div style={{ display: isActive ? "block" : "none" }}>{children}</div>
//       </Fade>
//     </div>
//   );
// };

// export default AtomTabPanel;


// const AtomTabPanel = ({ children }) => {
//   return (
//     <div
//       role="tabpanel"
//       style={{
//         width: "100%",
//       }}
//     >
//       {children}
//     </div>
//   );
// };

// export default AtomTabPanel;
